interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="pt-20 md:pt-24 pb-4 bg-background-50 border-b border-background-200/50">
      <div className="container-astro">
        <ol className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
          {items.map((item, i) => (
            <li key={item.label} className="flex items-center gap-2">
              {i > 0 && <i className="ri-arrow-right-s-line text-foreground-400" />}
              {item.href ? (
                <a
                  href={item.href}
                  className="hover:text-accent-600 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </a>
              ) : (
                <span className="text-foreground-950 font-medium whitespace-nowrap">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}